import { useEffect } from 'react';

const storageKey = 'trueimpact.ghostedUsername';
export function getGhostedUsername() {
  return sessionStorage.getItem(storageKey);
}

export function useStoreGhostedUsername(ghostedUsername) {
  useEffect(() => {
    if (ghostedUsername === null) {
      sessionStorage.removeItem(storageKey);
    } else {
      sessionStorage.setItem(storageKey, ghostedUsername);
    }
  }, [ghostedUsername]);
}
